// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eqAK5","bold":"Footer_bold__S0wS1","onlyMobile":"Footer_onlyMobile__+XANe","onlyDesktop":"Footer_onlyDesktop__uGlJp"};